export const translations = {
  sk: {
    nav: {
      home: "Úvod",
      about: "O nás",
      services: "Služby",
      reviews: "Recenzie",
      gallery: "Galéria",
      hours: "Hodiny",
      contact: "Kontakt",
      reserve: "Rezervovať",
    },
    gallery: {
      eyebrow: "Galéria",
      title: "Pohľad do nášho salónu",
      subtitle: "Prémiové prostredie v srdci Žiliny.",
    },
    hero: {
      eyebrow: "Kaderníctvo · Žilina",
      title1: "Luxury",
      title2: "Salón",
      subtitle: "Profesionálne kaderníctvo v Žiline.",
      tagline: "Štýl, elegancia a profesionálna starostlivosť o vaše vlasy.",
      cta_reserve: "Rezervovať termín",
      cta_call: "Zavolať",
      scroll: "Scroll",
    },
    about: {
      eyebrow: "O nás",
      title: "Krása vytvorená s vášňou",
      body: "V Luxury Salóne sa staráme o krásu a zdravie vašich vlasov s dôrazom na kvalitu, profesionalitu a individuálny prístup. Naše skúsené kaderníčky vytvárajú moderné strihy, styling aj farbenie podľa najnovších trendov.",
      stat1_value: "5,0 ★",
      stat1_label: "Google hodnotenie",
      stat2_value: "23+",
      stat2_label: "Recenzií",
      stat3_value: "10+",
      stat3_label: "Rokov skúseností",
    },
    services: {
      eyebrow: "Naše služby",
      title: "Salónne umenie",
      subtitle: "Komplexná starostlivosť o vaše vlasy v každom detaile.",
      items: [
        { name: "Dámske strihy", desc: "Precízne strihy navrhnuté presne pre vás." },
        { name: "Pánske strihy", desc: "Ostré línie, dokonalé prevedenie." },
        { name: "Farbenie vlasov", desc: "Trendy odtiene a profesionálne techniky." },
        { name: "Fúkanie vlasov", desc: "Lesk a objem na každý deň." },
        { name: "Vlasový styling", desc: "Účes presne podľa vašej predstavy." },
        { name: "Spoločenské účesy", desc: "Pre nezabudnuteľné príležitosti." },
        { name: "Strihy pre deti", desc: "Hravé prostredie pre tých najmenších." },
      ],
    },
    reviews: {
      eyebrow: "Recenzie klientov",
      title: "Hovorí za nás spokojnosť",
      rating: "5,0 / 5,0 — 23 recenzií na Google",
      see_all: "Pozrieť všetky recenzie na Google",
      list: [
        { text: "Spokojnosť nadovšetko. Milé pani kaderníčky a úžasná robota s vlasmi.", author: "Lucia Timkaničová" },
        { text: "Salón môžem vrelo odporučiť, stále usmiate kaderníčky a príjemné prostredie.", author: "Petra Gáborová" },
        { text: "Vynikajúci servis! Zatiaľ najlepší v Žiline.", author: "Pavol Babek" },
        { text: "Vysoká profesionalita, príjemné prostredie.", author: "Ľubica Joneková" },
      ],
    },
    hours: {
      eyebrow: "Otváracie hodiny",
      title: "Kedy nás navštívite",
      monfri: "Pondelok – Piatok",
      monfri_time: "Na objednávku",
      sat: "Sobota",
      sat_time: "Zatvorené",
      sun: "Nedeľa",
      sun_time: "Zatvorené",
      note: "Pre rezerváciu mimo otváracích hodín nás neváhajte kontaktovať.",
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Navštívte nás",
      address_label: "Adresa",
      address: "Hodžova 204/16, 010 01 Žilina",
      phone_label: "Telefón",
      phone: "0918 800 348",
      reserve_label: "Online rezervácia",
      reserve_text: "Rezervujte si termín cez Notino",
      reserve_cta: "Rezervovať na Notino",
      call_cta: "Zavolať teraz",
    },
    footer: {
      tagline: "Profesionálne kaderníctvo v Žiline",
      sections: "Sekcie",
      contact: "Kontakt",
      social: "Sociálne siete",
      rights: "Všetky práva vyhradené.",
      crafted: "Vytvorené s eleganciou.",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      reviews: "Reviews",
      gallery: "Gallery",
      hours: "Hours",
      contact: "Contact",
      reserve: "Book",
    },
    gallery: {
      eyebrow: "Gallery",
      title: "A glimpse inside our salon",
      subtitle: "A premium space in the heart of Žilina.",
    },
    hero: {
      eyebrow: "Hair Salon · Žilina",
      title1: "Luxury",
      title2: "Salón",
      subtitle: "Professional hair salon in Žilina.",
      tagline: "Style, elegance and professional care for your hair.",
      cta_reserve: "Book appointment",
      cta_call: "Call us",
      scroll: "Scroll",
    },
    about: {
      eyebrow: "About",
      title: "Beauty crafted with passion",
      body: "At Luxury Salón we take care of the beauty and health of your hair with a focus on quality, professionalism and an individual approach. Our experienced stylists create modern cuts, styling and colouring according to the latest trends.",
      stat1_value: "5.0 ★",
      stat1_label: "Google rating",
      stat2_value: "23+",
      stat2_label: "Reviews",
      stat3_value: "10+",
      stat3_label: "Years of experience",
    },
    services: {
      eyebrow: "Our services",
      title: "The art of the salon",
      subtitle: "Complete hair care, attention to every detail.",
      items: [
        { name: "Women's haircuts", desc: "Precise cuts tailored just for you." },
        { name: "Men's haircuts", desc: "Sharp lines, flawless execution." },
        { name: "Hair colouring", desc: "Trendy shades and professional techniques." },
        { name: "Blow-dry", desc: "Shine and volume for every day." },
        { name: "Hair styling", desc: "The look exactly as you imagine it." },
        { name: "Event hairstyles", desc: "For unforgettable occasions." },
        { name: "Kids haircuts", desc: "A playful space for the little ones." },
      ],
    },
    reviews: {
      eyebrow: "Client reviews",
      title: "Satisfaction speaks for us",
      rating: "5.0 / 5.0 — 23 reviews on Google",
      see_all: "See all reviews on Google",
      list: [
        { text: "Above all, satisfaction. Lovely stylists and amazing work with hair.", author: "Lucia Timkaničová" },
        { text: "I can warmly recommend the salon, always smiling stylists and pleasant atmosphere.", author: "Petra Gáborová" },
        { text: "Excellent service! The best in Žilina so far.", author: "Pavol Babek" },
        { text: "High professionalism, pleasant environment.", author: "Ľubica Joneková" },
      ],
    },
    hours: {
      eyebrow: "Opening hours",
      title: "When to visit us",
      monfri: "Monday – Friday",
      monfri_time: "By appointment",
      sat: "Saturday",
      sat_time: "Closed",
      sun: "Sunday",
      sun_time: "Closed",
      note: "For reservations outside opening hours, please contact us.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Visit us",
      address_label: "Address",
      address: "Hodžova 204/16, 010 01 Žilina",
      phone_label: "Phone",
      phone: "0918 800 348",
      reserve_label: "Online booking",
      reserve_text: "Book your appointment via Notino",
      reserve_cta: "Book on Notino",
      call_cta: "Call now",
    },
    footer: {
      tagline: "Professional hair salon in Žilina",
      sections: "Sections",
      contact: "Contact",
      social: "Social",
      rights: "All rights reserved.",
      crafted: "Crafted with elegance.",
    },
  },
};
